// Campus photo for /colleges/carleton-college: CC BY-SA 2.0, by Tony Webster from Minneapolis, Minnesota, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASkinner_Memorial_Chapel_-_Carleton_College_-_Northfield%2C_Minnesota_(25932797228).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/carleton-college/; credited under the photo.
const photo = {
    "slug": "carleton-college",
    "alt": "Skinner Memorial Chapel on a winter day at Carleton College in Northfield, Minnesota",
    "src": "/colleges/carleton-college/campus-1600.webp",
    "srcSmall": "/colleges/carleton-college/campus-800.webp",
    "srcMid": "/colleges/carleton-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/carleton-college/og.jpg",
    "title": "Skinner Memorial Chapel - Carleton College - Northfield, Minnesota (25932797228)",
    "author": "Tony Webster from Minneapolis, Minnesota, United States",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASkinner_Memorial_Chapel_-_Carleton_College_-_Northfield%2C_Minnesota_(25932797228).jpg",
    "read": "2026-10-01"
};

export default photo;
